<div class="layout-container">
	<app-header></app-header>
	<main class="content">
		<router-outlet></router-outlet>
	</main>
</div>
